// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".interaction-note-field .info-panel{margin-top:4px;margin-bottom:8px}", ""]);
// Exports
module.exports = exports;
